import React from "react";
import {Chip, makeStyles, TextField} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {RootState} from "../../store/root-reducer";
import {useSelector} from "react-redux";
import InputLabel from "@material-ui/core/InputLabel";
import styled from "styled-components";
import {Colors} from "../../theme/colors";

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: '0 !important',
        maxWidth: '100%',
        '& > * + *': {
            marginTop: theme.spacing(3),
        },
    },
    label: {
        color: '#758089 !important',
        fontSize: '0.9rem',
        fontWeight: 400,
        position: 'relative',
        lineHeight: '144%',
        transition: 'none',
        transform: 'none',
        marginBottom: '5px'
    }
}));

export const TagsSelect = ({setFieldValue, values, fieldName, label, error}) => {
    const tags = useSelector(
        (state: RootState) => state.tags.tags
    );
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <StyledAutocomplete
                multiple
                id={fieldName}
                options={tags}
                getOptionLabel={(option: any) => option.name}
                value={values[fieldName]}
                onChange={(event: any, newValue: any) => {
                    setFieldValue(fieldName, newValue);
                }}
                freeSolo
                renderTags={(value, getTagProps) => {
                    return value.map((option: any, index) => {
                        return <Chip variant="outlined" label={typeof option === 'string' ? option : option.name} {...getTagProps({ index })} />
                    });
                }}
                renderInput={(params) => {
                    // @ts-ignore
                    return <div ref={params.InputProps.ref}>
                        <InputLabel shrink htmlFor={'tags'} className={classes.label}>
                            {label}
                        </InputLabel>
                        <TextField
                            {...params}
                            variant="outlined"
                            error={error}
                            // style={{borderColor: '#6714A3'}}
                        />
                    </div>
                }}
            />
        </div>
    );
}

const StyledAutocomplete = styled(Autocomplete)`

  .MuiOutlinedInput-root {
    border-radius: 12px;
    background-color: #fff;

    fieldset {
      border-color: ${Colors.neutral90};
    }

    &:hover {
      fieldset {
        box-shadow: 0 0 0 4px ${Colors.warning95};
        border-color: ${Colors.primary70};
      }
    }

    &.Mui-focused {
      fieldset {
        border: 1px solid ${Colors.primary70};
      }
    }

    &.Mui-error {
      fieldset {
        border-color: ${Colors.error20};
      }

      &:hover {
        fieldset {
          box-shadow: 0 0 0 4px #F2B8B5;
        }
      }
    }
  }
`;
